var map = {
	"./en/4-2/tab1_active.png": 9599,
	"./en/4-2/tab2_active.png": 26694,
	"./en/4-2/tab3_active.png": 46169,
	"./fi/4-2/tab1_active.png": 12385,
	"./fi/4-2/tab2_active.png": 16260,
	"./fi/4-2/tab3_active.png": 69575,
	"./in/4-2/tab1_active.png": 22747,
	"./in/4-2/tab2_active.png": 42642,
	"./in/4-2/tab3_active.png": 12821,
	"./th/4-2/tab1_active.png": 6374,
	"./th/4-2/tab2_active.png": 78591,
	"./th/4-2/tab3_active.png": 48988,
	"./tw/4-2/tab1_active.png": 50485,
	"./tw/4-2/tab2_active.png": 23544,
	"./tw/4-2/tab3_active.png": 90843,
	"./wap/zh/4-2/tab_active.png": 34368,
	"./zh/4-2/tab1_active.png": 83072,
	"./zh/4-2/tab2_active.png": 56413,
	"./zh/4-2/tab3_active.png": 66042
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71134;